import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestDetailTestIds } from '../../../testids/FunctionGroupRequestDetailTestIds'

export const functionGroupRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/function-group-requests',
  texts: {
    [FunctionGroupRequestDetailTestIds.functionGroupRequestDetailPage]:
      'Detail view of a function-group request — its line items, justification, and current approval status.',
    [FunctionGroupRequestDetailTestIds.btnCancelRequest]:
      'Cancel the entire request. All pending line items are withdrawn and any approvers are notified.',
    [FunctionGroupRequestDetailTestIds.cardTitleJustification]:
      'Reason the requester provided for this access — reviewed by approvers and auditors when deciding.',
    [FunctionGroupRequestDetailTestIds.cardTitleRequestDetails]:
      'Header information for the request — requester, target identity, submitted timestamp, and overall status.',
    [FunctionGroupRequestDetailTestIds.requestStatusBadge]:
      'Current overall status of the request (pending, approved, rejected, cancelled, completed).',
  },
}
